/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

export const getAssetAttributeField = (attributeType) => {
    switch (attributeType) {
        case 'string' :
            return 'valueString'
        case 'date':
            return 'valueDate'
        case 'float':
            return 'valueFloat'
        case 'integer':
            return 'valueInteger'
        default:
            return 'valueString'
    }
}

export const getAssetAttributeValue = (attributeDefinition, attributeList) => {
    let value = '';

    if (!attributeList) {
        return (value);
    }

    attributeList.forEach((attr) => {
        if (attr.code === attributeDefinition.code) {
            value = attr[getAssetAttributeField(attributeDefinition.type)];
        }
    });

    if(typeof value === 'undefined') {
        value = '';
    }

    return(value);
}

